import { Stroke } from "yfiles";
import SIZES from "./styleSizes";
export default (color, selected) => new Stroke({
    thickness: selected ? SIZES.LINE_THICKNESS_SELECTED : SIZES.LINE_THICKNESS_DEFAULT,
    lineCap: "round",
    lineJoin: "round",
    fill: color
});
